@if (!!linkAppStore) {
<a [href]="linkAppStore" target="_blank"><img alt="app store" src="assets/images/market/app-store-badge.svg" /></a>
} @if (!!linkPlayMarket) {
<a [href]="linkPlayMarket" target="_blank">
  <img alt="google play" src="assets/images/market/google-play-badge.svg" />
</a>
}
